import React from 'react';
import PlainDropDownList from './PlainDropdownList';

const LANGUAGES = ['English', 'Spanish', 'Chinese', 'French', 'German', 'Arabic', 'Russian', 'Italian', 'Hindi'];

export default class LanguagesDropDownList extends PlainDropDownList {
    constructor(props) {
        super(props);
        this.label = loc('language-label');
        this.placeholder = loc('language-placeholder');
        this.items = LANGUAGES;
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/LanguagesDropDownList.js